module.exports = __webpack_public_path__ + "img/store_LINE.2f378b5d.svg";